<template>
  <div
    class="pauseRestoreBtn"
    :class="{
      'footer-container-tab': isFromTab || smallStyle,
      'footer-container-small': smallStyle,
      'footer-android-big': isAndroid && !isFromTab && !smallStyle,
    }"
  >
    <div class="btn-container">
      <rich-button @click="handlePauseRestore">
        {{ $t('FoodC_pause_qsCr_nszu') }}
      </rich-button>
    </div>
    <LoadingMask v-if="requestLoading" />
  </div>
</template>

<script>
import LoadingMask from '@/components/loading/loading-mask.vue'
import { MODULE_TYPE, SUCCESS_TYPE } from '@/page/member/common/enumsUtil.js'
import { resumeMembershipSubscription } from '@/api/member/index.js'
import mixin from '@/page/member/mixins.js'

export default {
  name: 'PauseFooter',
  components: {
    LoadingMask,
  },
  mixins: [mixin],
  inject: ['initCodeData'],
  props: {
    membership: {
      type: Object,
      default: () => {},
    },
    smallStyle: {
      // 管理页 按钮使用次级按钮 && 距离底部40
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      requestLoading: false,
    }
  },
  methods: {
    async handlePauseRestore() {
      this.membershipLandingCkFn(MODULE_TYPE.PAUSE_BUTTON)
      this.requestLoading = true
      const res = await resumeMembershipSubscription()
      this.requestLoading = false

      if (+res?.errno === 0) {
        // 暂停页没有注入该方法
        if (this.initCodeData) {
          await this.initCodeData()
        }
        const pauseSuccessDialogData = {
          date: this.membership?.renewDate,
          price: this.membership?.renewPriceSplit?.display,
        }
        this.$emit('onSuccess', {
          dialogData: pauseSuccessDialogData,
          type: SUCCESS_TYPE.pause,
        })
      } else {
        if (this.initCodeData) {
          await this.initCodeData()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixin.scss';

.pauseRestoreBtn {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 8;
  width: 100%;
  background: #ffffff;
  padding: 16px 24px 71px 24px;
  box-sizing: border-box;
  .btn-container {
    position: relative;
  }
  .rich-btn {
    @include globalBigBtn();
  }
  &.footer-container-tab {
    padding: 16px 24px;
    .btn-container {
      .rich-btn {
        @include globalSmallBtn();
      }
    }
  }
  &.footer-container-small {
    padding-bottom: 40px;
  }
  &.footer-android-big {
    padding-bottom: 40px;
  }
}
</style>
